<script lang="ts" setup>
import ComponentContainer from '~/components/content/bible/ComponentContainer.vue'

defineProps<{
  component: any
}>()

function getStyle(component: any) {
    if (component.style && component.style.sr) {
        return component.style.sr.id
    }
    return ''
}
</script>

<template>
  <template v-if="component">
    <template v-if="component['_'] === 't'">
      <span :class="getStyle(component)">{{ component.text }}</span>
    </template>
    <template v-else-if="component['_'] === 'vs'">
      <span :class="'v ' + getStyle(component)">{{
        component.reference.usfm.split('.')[2]
      }}.</span>
    </template>
    <template v-else-if="component['_'] === 've'" />
    <template v-else-if="component['_'] === 'cc'">
      <span :class="getStyle(component)">
        <ComponentContainer :component="component" />
      </span>
    </template>
    <template v-else>
      <span :class="getStyle(component)">{{ component }}</span>
    </template>
  </template>
</template>
